

// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { FaRegCopy } from 'react-icons/fa';

// const StudentidView = () => {
//   const [studentId, setStudentId] = useState(null);
//   const [error, setError] = useState(null);
//   const [copied, setCopied] = useState(false);
//   const user = localStorage.getItem('UserId');

//   const getdata = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API}/adddetails/getstudentid`,
//         { params: { userId: user } }
//       );
//       setStudentId(response.data.student_id);
//     } catch (err) {
//       console.error('Error fetching student ID:', err);
//       setError('Student ID not found. Please apply for the exam.');
//     }
//   };

//   useEffect(() => {
//     if (user) {
//       getdata();
//     }
//   }, [user]);

//   const copyToClipboard = () => {
//     if (studentId) {
//       navigator.clipboard.writeText(studentId.toString());
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <h1 style={styles.title}>🎓 Student ID Viewer</h1>

//       {studentId && (
//         <div style={styles.boxWrapper}>
//           <div style={styles.idBox}>
//             <span style={styles.idText}>{studentId}</span>
//             <FaRegCopy
//               onClick={copyToClipboard}
//               style={styles.copyIcon}
//               title="Copy Student ID"
//             />
//           </div>
//           {copied && <div style={styles.copied}>✅ Copied!</div>}
//         </div>
//       )}

//       {error && <p style={styles.error}>{error}</p>}
//     </div>
//   );
// };

// // ✅ Styles
// const styles = {
//   container: {
//     minHeight: '100vh',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//     background: 'linear-gradient(to right, #ece9e6, #ffffff)',
//     fontFamily: 'Segoe UI, sans-serif',
//   },
//   title: {
//     fontSize: '28px',
//     fontWeight: 'bold',
//     marginBottom: '30px',
//     color: '#333',
//   },
//   boxWrapper: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   idBox: {
//     display: 'flex',
//     alignItems: 'center',
//     background: 'linear-gradient(135deg, #74ebd5 0%, #9face6 100%)',
//     padding: '15px 25px',
//     borderRadius: '12px',
//     boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
//     fontSize: '20px',
//     color: '#fff',
//     fontWeight: '600',
//     cursor: 'default',
//     position: 'relative',
//   },
//   idText: {
//     marginRight: '12px',
//   },
//   copyIcon: {
//     cursor: 'pointer',
//     fontSize: '22px',
//     color: '#fff',
//     transition: 'transform 0.2s ease',
//   },
//   copied: {
//     marginTop: '10px',
//     color: '#28a745',
//     fontWeight: '500',
//     transition: 'opacity 0.3s ease',
//   },
//   error: {
//     color: 'red',
//     fontWeight: '500',
//     marginTop: '20px',
//   },
// };

// export default StudentidView;


import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaRegCopy, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const StudentidView = () => {
  const [studentId, setStudentId] = useState(null);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const user = localStorage.getItem('UserId');
  const navigate = useNavigate();

  const getdata = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/adddetails/getstudentid`,
        { params: { userId: user } }
      );
      setStudentId(response.data.student_id);
    } catch (err) {
      console.error('Error fetching student ID:', err);
      setError('❌ Student ID not found. Please apply for the exam.');
    }
  };

  useEffect(() => {
    if (user) {
      getdata();
    }
  }, [user]);

  const copyToClipboard = () => {
    if (studentId) {
      navigator.clipboard.writeText(studentId.toString());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={styles.container}>
      <button onClick={handleBack} style={styles.backButton}>
        <FaArrowLeft style={{ marginRight: '8px' }} />
        Back
      </button>

      <h1 style={styles.title}>🎓 Student ID Viewer</h1>

      {studentId && (
        <div style={styles.boxWrapper}>
          <div style={styles.idBox}>
            <span style={styles.idText}>{studentId}</span>
            <FaRegCopy
              onClick={copyToClipboard}
              style={styles.copyIcon}
              title="Copy Student ID"
            />
          </div>
          {copied && <div style={styles.copied}>✅ Copied to clipboard!</div>}
        </div>
      )}

      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

// 🎨 Enhanced styles
const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(to right, #a1c4fd, #c2e9fb)',
    padding: '20px',
    fontFamily: '"Poppins", sans-serif',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: '#222',
    marginBottom: '40px',
    textAlign: 'center',
  },
  boxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  idBox: {
    display: 'flex',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px 30px',
    borderRadius: '16px',
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)',
    fontSize: '22px',
    color: '#fff',
    fontWeight: '600',
    position: 'relative',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
  },
  idText: {
    marginRight: '16px',
    letterSpacing: '1px',
  },
  copyIcon: {
    fontSize: '24px',
    color: '#fff',
    transition: 'transform 0.3s ease',
  },
  copied: {
    marginTop: '12px',
    fontSize: '16px',
    color: '#28a745',
    fontWeight: '500',
    animation: 'fadeIn 0.5s',
  },
  error: {
    marginTop: '20px',
    color: '#dc3545',
    fontWeight: '600',
    fontSize: '16px',
  },
  backButton: {
    position: 'absolute',
    top: '30px',
    left: '30px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    color: '#333',
    border: '1px solid #ccc',
    borderRadius: '8px',
    padding: '8px 14px',
    fontSize: '16px',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
  },
};

export default StudentidView;
